var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRank8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.3772,
    r: 13.5293,
    fill: "url(#paint0_linear_4229_8361)",
    stroke: "url(#paint1_linear_4229_8361)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9972 21.0363C14.0919 21.0363 13.2831 20.8923 12.571 20.6045C11.8627 20.3128 11.3059 19.9189 10.9006 19.4227C10.4991 18.9227 10.2983 18.3583 10.2983 17.7295C10.2983 17.2484 10.4138 16.8071 10.6449 16.4056C10.8759 16.0041 11.1884 15.6708 11.5824 15.4056C11.9801 15.1367 12.4233 14.9643 12.9119 14.8886V14.7977C12.2718 14.6802 11.7472 14.3829 11.3381 13.9056C10.9328 13.4283 10.7301 12.8696 10.7301 12.2295C10.7301 11.6234 10.9138 11.0836 11.2812 10.6102C11.6525 10.1367 12.1581 9.76356 12.7983 9.49083C13.4422 9.21811 14.1752 9.08174 14.9972 9.08174C15.8191 9.08174 16.5502 9.21811 17.1903 9.49083C17.8343 9.76356 18.34 10.1367 18.7074 10.6102C19.0786 11.0836 19.2642 11.6234 19.2642 12.2295C19.2642 12.8734 19.0578 13.434 18.6449 13.9113C18.2358 14.3848 17.715 14.6802 17.0824 14.7977V14.8886C17.5672 14.9643 18.0066 15.1367 18.4006 15.4056C18.7983 15.6708 19.1127 16.0041 19.3438 16.4056C19.5786 16.8071 19.696 17.2484 19.696 17.7295C19.696 18.3583 19.4934 18.9227 19.0881 19.4227C18.6828 19.9189 18.1259 20.3128 17.4176 20.6045C16.7131 20.8923 15.9063 21.0363 14.9972 21.0363ZM14.9972 19.042C15.3419 19.042 15.6449 18.9776 15.9062 18.8488C16.1676 18.7162 16.3722 18.5325 16.5199 18.2977C16.6714 18.0628 16.7472 17.7977 16.7472 17.5022C16.7472 17.1992 16.6714 16.9302 16.5199 16.6954C16.3684 16.4605 16.16 16.2768 15.8949 16.1442C15.6335 16.0079 15.3343 15.9397 14.9972 15.9397C14.6638 15.9397 14.3646 16.0079 14.0994 16.1442C13.8343 16.2768 13.6259 16.4605 13.4744 16.6954C13.3229 16.9302 13.2472 17.1992 13.2472 17.5022C13.2472 17.7977 13.321 18.0628 13.4688 18.2977C13.6203 18.5287 13.8267 18.7105 14.0881 18.8431C14.3532 18.9757 14.6563 19.042 14.9972 19.042ZM14.9972 13.9567C15.2926 13.9567 15.554 13.8961 15.7812 13.7749C16.0123 13.6537 16.1922 13.4852 16.321 13.2692C16.4536 13.0533 16.5199 12.809 16.5199 12.5363C16.5199 12.2636 16.4536 12.023 16.321 11.8147C16.1922 11.6064 16.0142 11.4435 15.7869 11.3261C15.5597 11.2048 15.2964 11.1442 14.9972 11.1442C14.7017 11.1442 14.4384 11.2048 14.2074 11.3261C13.9763 11.4435 13.7964 11.6064 13.6676 11.8147C13.5388 12.023 13.4744 12.2636 13.4744 12.5363C13.4744 12.809 13.5388 13.0533 13.6676 13.2692C13.8002 13.4814 13.982 13.6499 14.2131 13.7749C14.4441 13.8961 14.7055 13.9567 14.9972 13.9567Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4229_8361",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3E52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4229_8361",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11273D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank8);
export default __webpack_public_path__ + "static/media/rank8.07bdd7668394747b2d3f973849f14c45.svg";
export { ForwardRef as ReactComponent };